import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as newsItemsApi from '../../api/postApi';
import * as actions from '../actions';
import * as selectors from '../selectors';
import moment from 'moment-timezone';
import * as api from '../../api/postApi';

const today = moment().startOf('day');
const tomorrow = today.clone().add(1, 'day');
const yesterday = today.clone().add(-1, 'day');
const startOfWeek = today.clone().startOf('week');
const endOfWeek = today.clone().endOf('week');
const lastWeek = today.clone().add(-7, 'days');
const startOfLastWeek = lastWeek.clone().startOf('week');
const endOfLastWeek = lastWeek.clone().endOf('week');
const startOfMonth = today.clone().startOf('month');
const previous30Days = today.clone().add(-30, 'days');
const startOfYear = today.clone().startOf('year');
const allTime = moment('01/01/2010', 'YYYY-MM-DD');
const dateFormat = 'YYYY-MM-DD';

const dates = {
  Today: [yesterday.format(dateFormat), tomorrow.format(dateFormat)],
  Yesterday: [yesterday.format(dateFormat), today.format(dateFormat)],
  'Last 7 Days': [lastWeek.format(dateFormat), today.format(dateFormat)],
  'This Week': [startOfWeek.format(dateFormat), endOfWeek.format(dateFormat)],
  'Last Week': [startOfLastWeek.format(dateFormat), endOfLastWeek.format(dateFormat)],
  'Month to Date': [startOfMonth.format(dateFormat), today.format(dateFormat)],
  'Last 30 Days': [previous30Days.format(dateFormat), today.format(dateFormat)],
  'This Year': [startOfYear.format(dateFormat), today.format(dateFormat)],
  'All Time': [allTime.format(dateFormat), moment().add(100, 'year').format(dateFormat)],
};

export function* enhanceNewsItem({ payload: { newsItem } }) {
  try {
    const post = yield call(api.getPostById, { siteId: newsItem.site_id, postId: newsItem.id });
    yield put(actions.content.enhanceNewsItemSuccess(post));
  } catch (e) {
    yield put(actions.content.enhanceNewsItemFail(e.message));
    toast.error('An error occurred retrieving the news item.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getNewsItems({ payload: { query } }) {
  try {
    // yield put(actions.user.setLoading(true));
    // yield put(actions.content.getNewsItemsSuccess([], 0, 0));
    const start_date = query.start_date ? dates[query.start_date][0] : '';
    const end_date = query.end_date ? dates[query.end_date][1] : '';
    const res = yield call(newsItemsApi.get, { ...query, start_date, end_date });
    const count = res.headers['x-count'];
    const pages = res.headers['x-pages'];
    const items = res.data;

    yield put(actions.content.getNewsItemsSuccess(items, count, pages));
  } catch (e) {
    yield put(actions.content.getNewsItemsFailure(e.message));
    // toast.error('An error occurred retrieving the news items.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* getNewsItemById({ payload: { id } }) {
  try {
    yield put(actions.user.setLoading(true));
    const item = yield call(newsItemsApi.getById, id);
    item.authors = item.authors.map(a => a.authorId);
    item.categories = item.categories.map(a => a.newscategoryId);
    item.siteData = item.sites;
    item.sites = item.sites.map(a => a.siteId);
    yield put(actions.content.getNewsItemByIdSuccess(item));
  } catch (e) {
    yield put(actions.content.getNewsItemByIdFailure(e.message));
    toast.error('An error occurred retrieving the news item.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* getAuthors() {
  try {
    const existing = yield select(selectors.content.authors);
    if (existing.length) {
      return;
    }
    const authors = yield call(newsItemsApi.all);
    const options = authors.map(a => {
      return {
        key: a.name,
        value: a.name,
        text: a.name,
      };
    });
    yield put(actions.content.getAuthorsSuccess(options));
  } catch (e) {
    yield put(actions.content.getAuthorsFailure(e.message));
    toast.error('An error occurred retrieving the authors.');
  }
}

export function* getSites() {
  try {
    const existing = yield select(selectors.content.sites);
    if (existing?.length) return;

    const sites = yield call(newsItemsApi.getSites);
    const options = sites.map(a => {
      return {
        key: a.id,
        value: a.id,
        text: a.name,
      };
    });
    yield put(actions.content.getSitesSuccess(options));
  } catch (e) {
    yield put(actions.content.getSitesFailure(e.message));
    toast.error('An error occurred retrieving the sites.');
  }
}
export function* updateNewsItem({ payload: { newsItem } }) {
  try {
    yield call(newsItemsApi.update, newsItem);
    yield put(actions.content.getNewsItemById(newsItem.id));
    yield put(actions.content.updateNewsItemSuccess(newsItem));
    toast.success('Changes saved.');
  } catch (e) {
    yield put(actions.content.updateNewsItemFailure(e.message));
    toast.error('An error occurred updating the news item.');
  }
}
export function* updateEvent({ payload: { event } }) {
  try {
    yield call(newsItemsApi.updateEvent, event);
    yield put(actions.content.updateEventSuccess());
    toast.success('Event update saved.');
  } catch (e) {
    yield put(actions.content.updateEventFailure(e.message));
    toast.error('An error occurred updating the event.');
  }
}
export function* addNewsItem({ payload: { newsItem } }) {
  try {
    console.log('addNewsItem saga', newsItem);
    const item = yield call(newsItemsApi.create, newsItem);
    window.open(`${item.editor_url}`, '_blank');
    yield put(actions.content.addNewsItemSuccess(item));
    toast.success('Changes saved.');
  } catch (e) {
    yield put(actions.content.addNewsItemFailure(e.message));
    toast.error('An error occurred creating the news item.');
  }
}
export function* cloneNewsItem({ payload: { siteId, sectionId, article } }) {
  try {
    yield put(actions.user.setLoading(true));
    const item = yield call(newsItemsApi.clone2, { siteId, sectionId, article });
    window.open(`${item.editor_url}`, '_blank');
    yield put(actions.content.cloneNewsItemSuccess(item));
    toast.success('Changes saved.');
  } catch (e) {
    yield put(actions.content.cloneNewsItemFailure(e.message));
    toast.error('An error occurred cloning the article.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* tagPost({ payload: { siteId, postId, tags } }) {
  try {
    yield call(newsItemsApi.tagPost, { siteId, postId, tags });
    yield put(actions.content.tagPostSuccess());
    toast.success('Changes saved.');
  } catch (e) {
    yield put(actions.content.tagPostFailure(e.message));
    toast.error('An error occurred updating the post.');
  }
}
export function* getPostById({ payload: { siteId, postId } }) {
  try {
    yield put(actions.user.setLoading(true));
    const post = yield call(newsItemsApi.getPostById, { siteId, postId });

    yield put(actions.content.getPostByIdSuccess(post));
  } catch (e) {
    yield put(actions.content.getPostByIdFailure(e.message));
    toast.error('An error occurred retrieving the post.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}
export function* publishDraftNewsItem({ payload: { newsItem } }) {
  try {
    yield put(actions.user.setLoading(true));
    yield call(newsItemsApi.publishDraftNewsItem, newsItem);
    yield put(actions.content.getNewsItemById(newsItem.id));
    yield put(actions.content.updateNewsItemSuccess(newsItem));
    toast.success('Changes saved.');
  } catch (e) {
    yield put(actions.content.updateNewsItemFailure(e.message));
    toast.error('An error occurred retrieving the news items.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* newsItemSagas() {
  yield takeEvery(actions.content.getNewsItems, getNewsItems);
  yield takeEvery(actions.content.getNewsItemById, getNewsItemById);
  yield takeEvery(actions.content.getAuthors, getAuthors);
  yield takeEvery(actions.content.getSites, getSites);
  yield takeEvery(actions.content.updateNewsItem, updateNewsItem);
  yield takeEvery(actions.content.publishDraftNewsItem, publishDraftNewsItem);
  yield takeEvery(actions.content.addNewsItem, addNewsItem);
  yield takeEvery(actions.content.cloneNewsItem, cloneNewsItem);
  yield takeEvery(actions.content.getPostById, getPostById);
  yield takeEvery(actions.content.updateEvent, updateEvent);
  yield takeEvery(actions.content.tagPost, tagPost);
}
